import React, { createContext, useContext, useState, useEffect } from "react"
import { useAppCtx } from "lib/state"
import { appTools, cn } from "lib/utils"
import { useTemplatePreviewCtx } from "lib/units/template/preview/TemplatePreviewProvider"
import { RenderStatement, RenderStatementsByParent, useDataCompare, useRenderStatement } from "."
import SectionHeaderRender from "../../SectionHeader/SectionHeaderRender"
import { useRenderStyling } from "lib/hooks/useRenderStyling"


const RenderStatementsContext = createContext({})
export const useRenderStatementsCtx = () => useContext(RenderStatementsContext)


export default function StatementsRender({ elemtype="opening_statements", showTests=false }:{ elemtype:string; showTests?:boolean }) {

  const { getElementConfig, clientApiData, template }:any = useTemplatePreviewCtx()
  // const config = getElementConfig(elemtype)

  const [ statements, setStatements ] = useState<any>()

  const outerWrapperStyling = useRenderStyling("mm-section w-full flex flex-col", "styleObj")
  const innerWrapperStyling = useRenderStyling("w-full flex flex-col pl-2 mt-3 mb-10", "styleObj")

  useEffect(() => {
    // console.log(statements)
    if(template && !statements){
      const found = template.Elements.find( (elem:any) => elem.refstr === elemtype )?.config.statements
      setStatements(found)
    }
  },[statements, template])

  if( !statements ) return <></>
  return (
    <div id={`mm-${elemtype}`} {...outerWrapperStyling}>
      
      { elemtype === "compelling_evidence" && (
        <SectionHeaderRender title="Compelling Evidence" />
      )}

      <div {...innerWrapperStyling}>
        <RenderStatementsByParent statements={statements} elemtype={elemtype} parent={["[root]"]} level={1} />
      </div>
    </div>
  )
}